<template>
  <form @submit.prevent="submitData" class="tw-w-full">
    <div class="tw-mt-4">
      <!-- N.B: placeholder value is used for validation. Update validation if placeholder value changes -->
      <OnboardingEmailInput
        placeHolder="Enter email address"
        label="Email address"
        :email="payload.email"
        :error="emailError || {}"
        :disabled="loading"
        @set="setEmail"
        @validate="validateMethod"
      />
    </div>
    <OnboardingBtn :loading="loading" title="Continue" />
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import navigateTo from "@/mixins/navigateTo";
import useValidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import OnboardingEmailInput from "@/components/onboarding/OnboardingEmailInput.vue";
import OnboardingBtn from "@/components/onboarding/OnboardingBtn.vue";

export default {
  name: "RequestLinkForm",

  components: {
    OnboardingEmailInput,
    OnboardingBtn,
  },

  mixins: [navigateTo],

  emits: ["submitData"],

  data() {
    return {
      v$: useValidate(),
      payload: {
        email: "",
      },
      emailError: {},
    };
  },

  validations() {
    return {
      payload: {
        email: { required, email },
      },
    };
  },

  computed: {
    ...mapState({
      loading: (state) => state.loadingModule.requestLinkLoading,
      success: (state) => state.loadingModule.requestLinkSuccess,
    }),
  },

  methods: {
    ...mapActions("loadingModule", ["requestLinkSuccess"]),

    submitData() {
      this.v$.$validate();
      const hasValue = Object.keys(this.payload).every(
        (key) => this.payload[key]
      );
      if (this.v$.$errors.length === 0 && hasValue) {
        this.$emit("submitData", this.payload);
      }
    },

    setEmail(email) {
      this.payload.email = email;
    },

    validateMethod(field) {
      switch (field) {
        case "Enter email address":
          this.v$.$reset();
          this.v$.payload.email.$touch();
          if (this.v$.$errors.length === 0) return (this.emailError = {});
          this.emailError = this.v$.$errors[0];
          break;

        default:
          break;
      }
    },
  },

  watch: {
    success(newValue) {
      deep: true;
      immediate: true;
      if (newValue === true) {
        this.payload = {
          email: "",
        };
        this.requestLinkSuccess(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
